import React from 'react';

export default ({
    name,
    even,
    last,
}) => {
    return <li className={`group no-expand${even ? " even" : ""}${last ? " last" : ""}`}>
        <div>
            <strong>
                {name}
            </strong>
        </div>
    </li>;
};